<template>
  <div v-if="links.length" class="shop-toolbar-links">
    <div class="shop-toolbar-links__list">
      <a
        v-for="(link, index) in links"
        :key="index"
        class="shop-toolbar-links__link"
        :href="link.url"
      >{{ link.text }}</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'horizontalLinkBoxes',
  computed: {
    links() {
      var raw = this.$root.settings && this.$root.settings.links
      if (!Array.isArray(raw)) {
        return []
      }
      return raw.filter(function(link) {
        return link && (link.text || link.url)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.shop-toolbar-links {
  display: flex;
  max-width: 100%;
  width: 100%;
  font-size: 1em;
  font-style: italic;
  font-weight: bolder;
  color: #004570;
}

.shop-toolbar-links__list {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  margin: 0;
  max-width: 100%;
  width: 100%;
}

.shop-toolbar-links__link {
  border: 1px solid #e8b75e;
  padding: 5px 30px;
  margin: 0;
  color: #004570;
  font-weight: bolder;
  text-decoration: none;
  display: inline-block;
  vertical-align: middle;
  transition: 0.2s background ease-in-out;
  box-sizing: border-box;

  &:hover {
    background: #fff2da;
    color: #004570;
  }
}

@media screen and (max-width: 700px) {
  .shop-toolbar-links {
    flex-direction: column;
    align-items: stretch;
  }

  .shop-toolbar-links__list {
    flex-direction: column;
    align-items: stretch;
  }

  .shop-toolbar-links__link {
    width: 100%;
    text-align: center;
  }
}
</style>
